import classNames from 'classnames';
import { t } from 'ttag';

import { Button } from '@ui/Button';
import { useRegion } from '@hook/useRegion';
import { refillBalance } from '@legacyUrls';

// styles
import s from './DebtWarning.sss';

// consts
export const themes = {
  lightOrange: s.lightOrange,
  red: s.red,
};

// types
type DebtWarningProps = {
  balance: number;
  theme: keyof typeof themes;
  className?: string;
};

export const DebtWarning: React.FC<DebtWarningProps> = ({
  balance,
  theme,
  className,
}) => {
  const region = useRegion();

  return (
    (
      <div
        className={classNames(
          s.root,
          themes[theme],
          className,
        )}
      >
        {t`У вас від'ємний баланс ${balance}`}
        {' '}
        {region.currencyName}
        {' '}
        :(
        <Button
          className={s.button}
          theme="noTheme"
          href={refillBalance}
        >
          {t`Поповнити`}
        </Button>
      </div>
    )
  );
};

export default DebtWarning;
